import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

const Error = () => {
	return (
		<div>
			<Header></Header>
			<br />
			<br />
			<br />
			<div class='row  mx-auto  p-5'>
				<div class='card text-center bg-gradient border-danger border-5' style={{ backgroundColor: '#003300' }}>
					<div class='card-body text-white'>
						<h1 class='card-title'>⚠️</h1>
						<p class='card-text'>
							<b>Oups...Désole de vous dire que la page que vous recherchez n'existe pas.</b>
						</p>
					</div>
				</div>
			</div>
			<br />
			<br />
			<br />
			<br />
			<Footer></Footer>
		</div>
	);
};

export default Error;
